import React from 'react';
import Card from '../../../../component/Card';

const Container = ({ children, marginTop = 3, full = false }) => {
  return (
    <div className={ `container${ full ? '-fluid' : '' }` }>
      <div className="row justify-content-center">
        <div className="col-lg-12">
          <Card marginTop={ marginTop }>
            <Card.Body>{children}</Card.Body>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Container;
